import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import { MAKE_UPS, StudentServicePath } from "utils/constants";
import ListMakeUps from "./List";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";
import { settings } from "app";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MU, tenants.MGU],
  icon: <HourglassTopIcon />,
  title: settings.tenant !== tenants.MGU ? "Отработване на упражнения" : "Извиняване на отсъствия",
  name: StudentServicePath + MAKE_UPS,
  list: <ListMakeUps />,
  permission: permissions.canPreviewMakeUps,
};
